// extracted by mini-css-extract-plugin
module.exports = {"completeBtn":"ClientSignature_completeBtn__3aDo4"};